import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { ButtonMenuVerticalComponent } from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import {
    UserMenuTheme,
    UserMenuThemeOption,
} from '../../../models/user-menu.model';
import { UserMenuSeparatorComponent } from '../user-menu-separator/user-menu-separator.component';
import { UserMenuTitleComponent } from '../user-menu-title/user-menu-title.component';

@Component({
    selector: 'interacta-user-menu-theme',
    templateUrl: './user-menu-theme.component.html',
    imports: [
        ButtonMenuVerticalComponent,
        TranslatePipe,
        UserMenuSeparatorComponent,
        UserMenuTitleComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuThemeComponent {
    readonly currentTheme = input.required<UserMenuTheme>();

    readonly changeTheme = output<UserMenuThemeOption>();
    readonly back = output<void>();
}
